import { render } from "./faqIndex.vue?vue&type=template&id=51cee82a"
import script from "./faqIndex.vue?vue&type=script&lang=js"
export * from "./faqIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__